import { Theme } from '@repo/types/src/glow-up';
import { ThemeCard } from './ThemeCard';

type ListProps = {
  themes: Theme[];
  refetch: () => void;
};

export const ThemeList = ({ themes, refetch }: ListProps) => {
  return (
    <div className="flex flex-col gap-4 h-full overflow-auto pb-12">
      <div className="flex flex-wrap gap-4">
        {themes.map((theme) => (
          <ThemeCard key={theme.id} theme={theme} refetch={refetch} />
        ))}
      </div>
    </div>
  );
};
